// extracted by mini-css-extract-plugin
export default {"link":"KlvTQp","ShinyButtonInverted":"bkdXTY","shinyButtonInverted":"bkdXTY","labelwrapper":"UljIi_","label":"e4bmeu"};